<template>
	<Loader :stretch="true" :inverse="true"></Loader>
</template>

<script>
	import { defineComponent } from 'vue';
	import Loader from '../components/Loader.vue';
	import { usePermissionsStore } from '@/store/store/permissionsStore';
	import { useFeatures } from '@/use/useFeatures';
	import { Permissions, PermissionLevels } from '@/models/permissions';

	export default defineComponent({
		components: {
			Loader,
		},
		async mounted() {
			const permissionsStore = usePermissionsStore();
			const roles = permissionsStore.currentUser.roles;
			if (!Array.isArray(roles) || roles.length === 0) {
				await permissionsStore.loadUserRolesFromStorage();
			}

			const { loadFeatures } = useFeatures();
			const features = await loadFeatures();

			const can = (permission) =>
				permissionsStore.hasAccess(permission, PermissionLevels.Read);

			// Land on the first area the user can actually access (nav order). Reports
			// also requires the Power BI feature flag. If they can access nothing,
			// send them to a friendly "no access" page instead of an empty dashboard.
			let target = '/no-access';
			if (can(Permissions.Applications)) target = '/applications';
			else if (can(Permissions.Loans)) target = '/loans';
			else if (can(Permissions.CertAndDisburse)) target = '/certifications';
			else if (can(Permissions.DisbursementBatches)) target = '/batches';
			else if (can(Permissions.Reports) && features?.powerBIReporting) target = '/reports';

			this.$router.replace({ path: target });
		},
	});
</script>
